function SSO() {
  return <div></div>;
}

export default SSO;
